/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=2122ccaa&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2122ccaa&scoped=true&lang=css"

import exportComponent from "D:\\项目\\检后\\Prc_HealthManagement_Question_FrontCode\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2122ccaa"]])

export default __exports__